<template>
    <div class="detail">
        <!-- <navbar title="动态详情" /> -->
        <template v-if="!shownull && detail.noticeContent">
            <div class="content ql-snow">
                <div class="title">{{detail.noticeSubject}}</div>
                <div class="desc">
                    <div class="des">{{detail.schoolName}}</div>
                    <div class="time">{{detail.createDate}}</div>
                </div>
                <div class="rawHtml ql-editor" v-html="detail.noticeContent"></div>
            </div>
            <div class="praise">
                <div class="read">阅读：{{detail.readVolume}}</div>
            </div>
        </template>
        <template v-if="shownull">
            <div class="nullbox">
                <img src="https://cdn.mall.51wom.com/编组2@2x_20210831162128.png" alt="">
                <p>学校通知内容已被删除</p>
            </div>
        </template>
    </div>
</template>

<script>
import navbar from '@/components/navbar/index';
import { getSchoolNoticeById } from '@/api/officialDynamic'
export default {
    name: 'articleDetail',
    components: {
        navbar
    },
    data() {
        return {
            detail: {
                noticeSubject: '',
                schoolName: '',
                createDate: '',
                noticeContent:'',
                readVolume: '',
            },
            query: {
                
            },
            noticeId: '',
            shownull: false
        }
    },
    created() {
        if(this.$route.params.id) {
            this.noticeId = this.$route.params.id
        }
        this.querySchoolNoticeById();
    },
    methods: {
        querySchoolNoticeById() {
            getSchoolNoticeById(
                {
                    noticeId: this.noticeId
                }
            )
            .then(res => {
                console.log(res)
                if(res.status === 200 && res.content) {
                    this.detail = res.content;
                    this.shownull = false;
                }
                else {
                    this.shownull = true;
                }
            })
        }
        
    }
}
</script>

<style lang="scss" scoped>
.detail {
    display: flex;
    flex-direction: column;
    height: 100vh;
    .leftarrow {
        width: .24rem;
        height: .4rem;
    }
    .blackdot {
        width: .46rem;
        height: .1rem;
    }
    .content {
        padding: .36rem 0;
        flex: 1;
        .title {
            padding: 0 .36rem;
            font-size: .4rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #222222;
            margin-bottom: .22rem;
        }
        .desc {
            padding: 0 .36rem;
            display: flex;
            font-size: .26rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            .des {
                margin-right: .4rem;
            }
        }
    }
    .praise {
        padding: .36rem .4rem;
        display: flex;
        justify-content: space-between;
        .read {
            font-size: .3rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
        }
    }
    .nullbox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top:40%;
        img {
            width: 5.3rem;
            height: 4.5rem;
        }
        p {
            font-size: .28rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            margin-top: .1rem;
        }
    }
}
</style>